import type { JoggStore } from "@jog/types"

import { gtmPush } from "."

export const gtmStoreLocatorSearchSubmitted = (search: string) => {
    gtmPush({ event: "store_search_submitted", search })
}

export const gtmStoreLocatorResultClicked = (store: Pick<JoggStore, "storeNumber" | "town">) => {
    if (!store) return
    gtmPush({
        event: "store_result_clicked",
        store: { number: store.storeNumber, name: store.town },
    })
}

export const gtmStoreRouteButtonClicked = (store: Pick<JoggStore, "storeNumber" | "town">) => {
    if (!store) return
    gtmPush({ event: "route_button_clicked", store: { number: store.storeNumber, name: store.town } })
}

export const gtmStorePhoneNumberClicked = (store: Pick<JoggStore, "storeNumber" | "town" | "phone">) => {
    if (!store) return
    gtmPush({
        event: "phone_number_clicked",
        store: { number: store.storeNumber, name: store.town, phone: store.phone },
    })
}
